module.exports = __webpack_public_path__ + "static/media/planetz3.4c8ba50f.png";